import { render } from "./AccountRecoverForm.vue?vue&type=template&id=9a7b4cd8&lang=en"
import script from "./AccountRecoverForm.vue?vue&type=script&lang=js"
export * from "./AccountRecoverForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__